import { Reducer } from 'redux';

import { IBlogsState } from 'types/blogs.types';
import * as constants from 'redux/constants/blogs.constants';

export const defaultState: IBlogsState = {
  count: 0,
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'createdAt',
    sortType: 'desc',
  },
};

const blogsReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.BLOGS_ON_DELETE_REQUESTED:
    case constants.BLOGS_ON_GET_ALL_REQUESTED:
    case constants.BLOGS_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.BLOGS_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.BLOGS_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.BLOGS_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.BLOGS_ON_DELETE_SUCCEEDED:
    case constants.BLOGS_ON_SAVE_SUCCEEDED:
    case constants.BLOGS_ON_DELETE_FAILED:
    case constants.BLOGS_ON_GET_ALL_FAILED:
    case constants.BLOGS_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.BLOGS_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    default:
      return state;
  }
};

export default blogsReducer;
